﻿import $ from 'jquery';
import { PopOver, IPopoverOptions } from "./popover";

declare global {
  interface JQuery {
    remotePopover(option?: any): JQuery;
  }
}

export class RemotePopOver extends PopOver{
  public static wireup: string = '[data-remotepopover]';
  constructor(element: JQuery, options: IPopoverOptions) {
    super(element, options)
  }

  protected init() {
    var url = this.$element.data("popover-url");
    if (url.length == 0)
      throw new Error("you must specify a url when using RemotePopover");
    this.options.popover = url;

    this.options.getContent = function (popover: RemotePopOver) {
      var d = $.Deferred();
      popover.$element.remote({
        url: url,
        success: function (data) {
          data = $(data).attr('data-remotepopover-content', 'on')[0].outerHTML;
          d.resolve(data);
        }
      });
      return d.promise();
    }

    super.init();
  }
}

($ => {
  function plugin(option) {
    return this.each(function() {
      var $this = $(this);
      var data = $this.data('rustig.remotepopover');
      var options = typeof option == 'object' && option;

      if (!data) {
        data = new RemotePopOver(this, options);
        $this.data('rustig.remotepopover', data);
      }
      if (typeof option == 'string')
        data[option]();
    });
  }

  $.fn.remotePopover = plugin;
})($);